import Vue from 'vue'
import _ from 'lodash'

// https://github.com/vuejs/vue/blob/dev/src/core/vdom/vnode.js

export function isVNode(node) {
  return node !== null && typeof node === 'object' && node.hasOwnProperty('componentOptions')
}

export function isVueComponent(node) {
  return node && node._isVue
}

export function getFirstComponentChild(children) {
  // 非 text node
  return children && _.filter(children, (child) => child && child.tag)[0]
}

export function getComponentsByName(children, name) {
  return _.filter(children, (child) => {
    const childName = child._isVue ? child.$options.name || child.$options._componentTag : child.name
    if (childName) {
      return _.upperCase(childName) === _.upperCase(name)
    }
    return false
  })
}

export function getFirstDescendantComponentByName(component, name) {
  if (!component) {
    return null
  }

  const components = getComponentsByName(component.$children, name)
  if (components.length) {
    return components[0]
  }

  let targetComponent = null
  _.forEach(component.$children, child => {
    targetComponent = getFirstDescendantComponentByName(child, name)
    if (targetComponent) {
      return false
    }
  })

  return targetComponent
}

export function getAllDescendantComponentsByName(component, name, result = []) {
  if (!component) {
    return []
  }

  _.forEach(component.$children, child => {
    const childName = child._isVue ? child.$options.name || child.$options._componentTag : child.name
    if (_.upperCase(childName) === _.upperCase(name)) {
      result.push(child)
    }

    return getAllDescendantComponentsByName(child, name, result)
  })

  return result
}

export function getParentByName(component, name) {
  if (!component) {
    return null
  }
  const { $parent } = component

  if ($parent && $parent.$options && $parent.$options.name === name) {
    return $parent
  }

  return getParentByName($parent, name)
}

export function isComponentGlobalRegistered(componentName) {
  return componentName in Vue.options.components
}

// export const getInnerText = function(children) {
//   children = _.isArray(children) ? children : [children]
//   return _.map(children, node => {
//     return node.children && node.children.length
//       ? getInnerText(node.children)
//       : node.text
//   }).join('')
// }
